import {
  Dispatch,
  SetStateAction,
  useCallback,
  useMemo,
  useState,
} from 'react';

interface UseBooleanOutput {
  setValue: Dispatch<SetStateAction<boolean>>;
  setTrue: () => void;
  setFalse: () => void;
  toggle: () => void;
}

function useBoolean(defaultValue: boolean): [boolean, UseBooleanOutput] {
  const [value, setValue] = useState(defaultValue);

  const setTrue = useCallback(() => setValue(true), []);
  const setFalse = useCallback(() => setValue(false), []);
  const toggle = useCallback(() => setValue((x) => !x), []);

  const actions = useMemo(
    () => ({
      setValue,
      toggle,
      setTrue,
      setFalse,
    }),
    [setValue, toggle, setTrue, setFalse]
  );

  return useMemo(() => [value, actions], [value, actions]);
}

export default useBoolean;
